import {FOOTBALL_MODULE} from '../../../../constants/identifiers';
import {FOOTBALL_MODULE_NAME, FOOTBALL_MODULE_PATH} from './constants/identifiers';
import reducers from './reducers';

export default {id: FOOTBALL_MODULE, name: FOOTBALL_MODULE_NAME, path: FOOTBALL_MODULE_PATH, reducers};



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/modules/football/index.js